<template>
  <div class="dt-row-user">
    <!-- New row -->
    <div class="dt-row-detail" :class="{'active': index % 2 == 1}">
      <div class="body-col" :style="{ width: columnWidth.firstName.size ? (columnWidth.firstName.size + 'px') : '10%' }">
      </div>
      <div class="body-col" :style="{ width: columnWidth.lastName.size ? (columnWidth.lastName.size + 'px') : '35%' }">
        {{ validator.name }}
      </div>
      <div class="body-col" :style="{ width: columnWidth.email.size ? (columnWidth.email.size + 'px') : '45%' }">
        {{ validator.field }}
      </div>
      <!--<div class="body-col" :style="{ width: columnWidth.clientAccount.size ? (columnWidth.clientAccount.size + 'px') : '15%' }">
        {{ clientName }}
      </div>
      <div class="body-col" :style="{ width: columnWidth.role.size ? (columnWidth.role.size + 'px') : '15%' }">
        {{ showRoleText }}
      </div>-->
      <div class="body-col" :style="{ width: columnWidth.action.size ? (columnWidth.action.size + 'px') : '10%' }">
        <div class="wrapper" @click="editValidator()">
          <span>
            <Icon v-b-tooltip.hover.bottom :title="instructions.edit" name="pencil" class="icon"></Icon>
          </span>
        </div>
        <!--<div class="wrapper" @click="deleteValidator()">-->
          <!--<span>-->
            <!--<Icon v-b-tooltip.hover.bottom :title="instructions.delete" :name="iconNames.trashO" class="icon"></Icon>-->
          <!--</span>-->
        <!--</div>-->
      </div>
    </div>
  </div>
</template>

<script>
import Icon from 'vue-awesome/components/Icon';
import constants from '../../_consts';
import { mapGetters } from 'vuex';

export default {
  name: 'UserRow',
  components: {
    Icon
  },
  props: {
    index: {
      type: Number,
      default: -1
    },
    validator: {
      type: Object,
      default: {}
    }
  },
  data () {
    return {
      instructions: constants.instructions,
      iconNames: constants.iconNames
    };
  },
  computed: {
    showRoleText () {
      let roles = constants.USER_ROLE;
      let userRole = this.userInfo.role;
      if (userRole.toLowerCase() === roles.client.toLowerCase() || userRole.toLowerCase() === roles.clientManager.toLowerCase()) {
        return 'Client';
      }
      if (userRole.toLowerCase() === roles.accountManager.toLowerCase() || userRole.toLowerCase() === roles.secondaryAccountManager.toLowerCase()) {
        return 'AM';
      }
      if (userRole.toLowerCase() === roles.eventManager.toLowerCase()) {
        return 'EM';
      }
      if (userRole.toLowerCase() === roles.admin.toLowerCase()) {
        return 'Admin';
      }
      return '';
    },
    ...mapGetters({
      columnWidth: 'GETTER_GET_COLUMN_TABLE_USER'
    })
  },
  methods: {
    editValidator () {
      let modalData = {
        action: constants.modalAction.editValidator,
        data: this.validator
      };
      this.$modal.show('eventModal', modalData);
    },
    deleteValidator () {
      let modalData = {
        action: constants.modalAction.deleteValidator,
        data: this.validator
      };
      this.$modal.show('eventModal', modalData);
    },
    forceUserResetPassword () {
      let modalData = {
        action: constants.modalAction.forceUserResetPassword,
        data: this.userInfo
      };
      this.$modal.show('eventModal', modalData);
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../styles/variables.less';
.dt-row-user{
  font-family: "Open Sans",serif;
  background-color: #ffffff;
  .active{
    .body-col{
      background-color: #f5f5f5;
    }
  }
  .dt-row-detail{
    .body-col{
      color: #231F20;
      font-size: 14px;
      .wrapper{
        width: 24px;
        background-color: @light-blue;
        height: 24px;
        margin-top: 5px;
        border-radius: 4px;
        position: relative;
        display: inline-block;
        .icon{
          // margin-top: 10px;
          position: absolute;
          top: 2px;
          left: 2px;
          background-color: @light-blue;
          color: #fff;
          height: 20px;
          width: 20px;
          border-radius: 4px;
          &:hover{
            cursor: pointer;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// GlobalSettingsRow.vue?071ef570